import { Highcharts } from "highcharts/modules/map";
import { Axis } from "highcharts";

type Limits = {
    min: number,
    max: number
}

// Обработчик приближения и отдаления зума графика при скролле колесика мыши
export const handleChartWheelScroll = (chartRef: Highcharts.Chart | undefined, direction: 'xAxis' | 'yAxis', preventScrollWhenZoom = true) => {
    const zoomLimits: Limits = { min: 0, max: 0 }
    const wheelLimits: Limits = { min: 0, max: 0 }
    return (event: WheelEvent) => {
        if (chartRef) {
            if (event.ctrlKey) {
                handleWheelZoom(direction === 'xAxis' ? chartRef.xAxis[0] : chartRef.yAxis[0], chartRef, event, zoomLimits)
            } else {
                !preventScrollWhenZoom && handleWheelScroll(direction === 'xAxis' ? chartRef.yAxis[0] : chartRef.xAxis[0], chartRef, event, wheelLimits)
            }

            event.preventDefault();
            event.stopImmediatePropagation();
        }
    }
}

const handleWheelZoom = (axis: Axis, chartRef: Highcharts.Chart, event: WheelEvent, limits: Limits) => {
    // получаем значения крайних точек
    const currentExtremes = axis.getExtremes();

    // обновляем максимальные значения
    if (limits.min === 0) limits.min = currentExtremes.min
    if (limits.max === 0) limits.max = currentExtremes.max

    // получаем множитель в зависимости от положения мыши
    const multRange = event.deltaY > 0 ? 1.2 : 0.833;

    // высчитываем новые крайние положения
    const mousePos = chartRef.pointer.normalize(event);
    const xValue = axis.toValue(mousePos.chartX);
    const newMinX = xValue - (xValue - currentExtremes.min) * multRange;
    const newMaxX = xValue + (currentExtremes.max - xValue) * multRange;

    // Если текущий минимум <= минимально возможному и текущий максимум >= максимально допустимого, то показываем кнопку сброса
    if ((currentExtremes.min <= limits.min) && (currentExtremes.max >= limits.max)) {
        chartRef.zoomOut();
        chartRef.showResetZoom();
    }

    if ((newMinX < limits.min) && (newMaxX > limits.max)) {
        axis.setExtremes(limits.min, limits.max);
        chartRef.zoomOut();
    } else if((newMinX < limits.min)) {
        axis.setExtremes(limits.min, newMaxX);
    } else if (newMaxX > limits.max) {
        axis.setExtremes(newMinX, limits.max);
    } else {
        axis.setExtremes(newMinX, newMaxX);
    }
}

const handleWheelScroll = (axis: Axis, chartRef: Highcharts.Chart, event: WheelEvent, wheelLimits: Limits) => {
    const { min, max, dataMin, dataMax, userMin = 0, userMax = 0 } = axis.getExtremes()
    const e = chartRef.pointer.normalize(event);
    const delta = (e.detail || - (event.deltaY / 120)) <0 ? 1 : -1

    if (wheelLimits.min === 0) wheelLimits.min = dataMin
    if (wheelLimits.max === 0) wheelLimits.max = dataMax

    const step = (max - min) / 5 * delta

    const newMin = min + step
    const newMax = max + step

    if (delta === 1) {
        if (newMax < wheelLimits.max) {
            axis.setExtremes(newMin, newMax)
        } else {
            if (userMin) axis.setExtremes(userMin + Math.abs(wheelLimits.max - userMax), wheelLimits.max)
        }
    } else {
        if (newMin >= wheelLimits.min) {
            axis.setExtremes(newMin, newMax)
        } else {
            if (userMax) axis.setExtremes(wheelLimits.min, userMax - Math.abs(userMin - wheelLimits.min))
        }
    }
}